<div class="select-overlay">
  <button #openBtn
          type="button"
          class="select-overlay__open ongray {{buttonClass}}"
          [ngClass]="selectedItem?.name ? 'select-overlay--filled' : 'select-overlay--empty'"
          (click)="expanded = true">
    <div class="d-inline-flex">
      <div class="truncate">{{ selectedItem?.name || 'Select Campaign' }}</div>
    </div>
    <i class="fas fa-fw fa-caret-down float-r"></i>
  </button>
  <div *ngIf="expanded"
       class="select-overlay select-overlay__content"
       appOutsideClick
       (outsideClicked)="expanded = false"
       [outsideClickIgnoreEls]="[openBtn]">
    <app-campaign-quicksearch [resultsFilterFn]="resultsFilterFn"
                              (itemSelected)="onQuickSearchItemSelected($event)"></app-campaign-quicksearch>
  </div>
</div>
